// extracted by mini-css-extract-plugin
export default {"on-error-page":"OnErrorPage_on-error-page__XJJj2"};